import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import CourseTypeIcon from "../Icons/CourseTypeIcon";
import IltClassLocation from "./IltClassLocation";
import IltClassInstructor from "./IltClassInstructor";
import { formatDate } from "../../utils/datetime";
import { iltScheduledAt } from "../../utils/course_utils";
import { InsertInvitation as CalendarIcon } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import { Tooltip } from "../Tooltip";

const ScheduledDate = ({ scheduledDate, scheduledTime, endDate, endTime }) => {
  const theme = useTheme();

  const endDateTime =
    endDate && endDate !== scheduledDate
      ? `${formatDate(endDate)} ${endTime}`
      : `${endTime ? endTime : ""}`;
  const scheduledDateAndTime =
    `${formatDate(scheduledDate)} ` +
    (endDateTime
      ? `${scheduledTime} - ${endDateTime}`
      : `${iltScheduledAt(scheduledTime)}`);
  return (
    <Box display="flex">
      <Box mr={1} color={theme.palette.action.disabled}>
        <CalendarIcon fontSize="small" />
      </Box>
      <Typography variant="caption" color="textSecondary">
        {scheduledDateAndTime}
      </Typography>
    </Box>
  );
};

const IltClassInfo = ({ course, showCourseTypeIcon }) => {
  const theme = useTheme();

  const iltClassInfo = (
    <Box display="flex">
      <Box display="flex" height={24} alignItems="center">
        {showCourseTypeIcon && (
          <CourseTypeIcon type={course.typeName} size="small" />
        )}
      </Box>
      <Box display="flex" flexDirection="column" pl={{ xs: 1, sm: 2 }}>
        <Box display="flex">
          <Typography variant="subtitle1" color="textPrimary">
            {course.name}
          </Typography>
        </Box>
        <Box
          mt={0.5}
          display="flex"
          flexDirection="column"
          color={theme.palette.action.disabled}
          ml={{ xs: -3, sm: 0 }}
        >
          {course.iltInfo && (
            <IltClassInstructor
              instructorName={course.iltInfo?.instructor?.name || ""}
            />
          )}
          <ScheduledDate
            scheduledDate={course.scheduledDate}
            scheduledTime={course.scheduledTime}
            endDate={course.endDate}
            endTime={course.endTime}
          />
          {course.iltInfo && (
            <IltClassLocation
              location={course.iltInfo.trainingLocation}
              courseType={course.typeName}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
  return course.description ? (
    <Tooltip
      title={
        <Typography variant="body2" color="textPrimary">
          {course.description}
        </Typography>
      }
    >
      {iltClassInfo}
    </Tooltip>
  ) : (
    iltClassInfo
  );
};

IltClassInfo.propTypes = {
  showCourseTypeIcon: PropTypes.bool,
  course: PropTypes.any
};

export default IltClassInfo;
